<template>
	<AgItem :rowData="soldReceivablesRowData"
			:columnDefs="soldReceivablesColumnDefs"
			min-height="164px"
			height-type="matchRows"
			v-on:sortChanged="sortChanged"
	/>
</template>

<script>
import AgItem from "@/components/templates/agGrid/AgItem";
import {asLocalizedDate, asMoneyAmount} from "@/components/templates/agGrid/formatter/valueFormatters";

export default {
	props: {
		listFunc: { type: Function, default: (postData) => {} },
	},
	components: {
		AgItem,
	},
	data() {
		return {
			soldReceivablesRowData: null,
			soldReceivablesColumnDefs: [],
			sorting: [],
		};
	},
	beforeMount() {
		this.setColumnDefs();
		this.getList();
	},
	methods: {
		setColumnDefs() {
			this.soldReceivablesColumnDefs = [
				{
					headerName: this.$t("common.invoiceNumber"),
					field: "invoiceNumber",
					sortable: true
				},
				{
					headerName: this.$t("common.amount"),
					headerClass: "align-right",
					field: "amount",
					cellStyle: {'justify-content': 'flex-end'},
					valueFormatter: asMoneyAmount(),
					sortable: true
				},
				{
					headerName: this.$t("common.dueDate"),
					field: "dueDate",
					valueFormatter: asLocalizedDate(),
					sortable: true
				},
				{
					headerName: this.$t("revolvingPutOption.repaid"),
					cellRendererFramework: "RevolvingPutOptionSoldReceivablesPaymentStatusRenderer",
				}
			]
		},
		sortChanged(sortData) {
			this.sorting = sortData;
			this.getList();
		},
		getList() {
			let postData = {
				columns: [],
				filters: [],
				maxResults: 100,
				offset: 0,
				sorting: this.sorting
			};

			this.listFunc(postData)
				.then((res) => {
					this.soldReceivablesRowData = res.data;
				})
				.catch(this.toast);
		}
	},
};
</script>